import { useState } from "react";
import { TCalendarBooking, TLodging } from "../../types/types";

const BookingPricingStructure = (props: { selectedLodging: TLodging, editedBooking: TCalendarBooking, handleInputChange: Function, setEditedBooking: Function }) => {
    const { selectedLodging, editedBooking, handleInputChange, setEditedBooking } = props;

    const [selectedPricingKey, setSelectedPricingKey] = useState(editedBooking.pricing_structure_json.selected_pricing || "persons-1");
    const unitOrCampsite = selectedLodging.pricing_structure_json.campsite ? "campsite" : "unit";
    const pricingStructureKeys = Object.keys(selectedLodging.pricing_structure_json);
    pricingStructureKeys.sort((a, b) => a.localeCompare(b));

    const handlePricingStructureChange = (newKey: string) => {
        setEditedBooking({
            ...editedBooking,
            pricing_structure_json: selectedLodging.pricing_structure_json[newKey]
        } as TCalendarBooking);
        setSelectedPricingKey(newKey);
    }

    //@ts-ignore
    const selectedPricing = selectedLodging.pricing_structure_json[selectedPricingKey];
    console.log(editedBooking.pricing_structure_json);
    return (<div className="booking-info-section">

        {selectedLodging.pricing_structure_json.campsite && (<>
            <h3>CAMPSITE: {selectedLodging.description}, max {selectedLodging.max_occupancy} persons</h3>
            <form className="booking-form">
                <div className="form-group">
                    <label htmlFor="adult_price">Adult price</label>
                    <input
                        id="adult_price"
                        type="number"
                        min={0}
                        value={editedBooking.pricing_structure_json?.adult_price || selectedLodging.pricing_structure_json[unitOrCampsite]?.adult_price}
                        onChange={(e) => handleInputChange(e.target.value, "adult_price")}
                        className="form-input"
                        required
                        disabled={editedBooking.booking_id ? true : false}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="adults"># Adults</label>
                    <input
                        id="adults"
                        type="number"
                        min={0}
                        value={editedBooking.pricing_structure_json?.adults || 0}
                        onChange={(e) => handleInputChange(e.target.value, "adults")}
                        className="form-input"
                        required
                        disabled={editedBooking.booking_id ? true : false}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="child_price">Child price</label>
                    <input
                        id="child_price"
                        type="number"
                        min={0}
                        value={editedBooking.pricing_structure_json?.child_price || selectedLodging.pricing_structure_json[unitOrCampsite]?.child_price}
                        onChange={(e) => handleInputChange(e.target.value, "child_price")}
                        className="form-input"
                        required
                        disabled={editedBooking.booking_id ? true : false}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="children"># Children</label>
                    <input
                        id="children"
                        type="number"
                        min={0}
                        value={editedBooking.pricing_structure_json?.children || 0}
                        onChange={(e) => handleInputChange(e.target.value, "children")}
                        className="form-input"
                        required
                        disabled={editedBooking.booking_id ? true : false}
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="infant_price">Infant price</label>
                    <input
                        id="infant_price"
                        type="number"
                        min={0}
                        value={editedBooking.pricing_structure_json?.infant_price || selectedLodging.pricing_structure_json[unitOrCampsite]?.infant_price}
                        onChange={(e) => handleInputChange(e.target.value, "infant_price")}
                        className="form-input"
                        required
                        disabled={editedBooking.booking_id ? true : false}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="infants"># Infants</label>
                    <input
                        id="infants"
                        type="number"
                        min={0}
                        value={editedBooking.pricing_structure_json?.infants || 0}
                        onChange={(e) => handleInputChange(e.target.value, "infants")}
                        className="form-input"
                        required
                        disabled={editedBooking.booking_id ? true : false}
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="pensioner_price">Pensioner price</label>
                    <input
                        id="pensioner_price"
                        type="number"
                        min={0}
                        value={editedBooking.pricing_structure_json?.pensioner_price || 0}
                        onChange={(e) => handleInputChange(e.target.value, "pensioner_price")}
                        className="form-input"
                        required
                        disabled={editedBooking.booking_id ? true : false}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="pensioners"># Pensioners</label>
                    <input
                        id="pensioners"
                        type="number"
                        min={0}
                        value={editedBooking.pricing_structure_json?.pensioners || 0}
                        onChange={(e) => handleInputChange(e.target.value, "pensioners")}
                        className="form-input"
                        required
                        disabled={editedBooking.booking_id ? true : false}
                    />
                </div>
            </form>
        </>)}
        {selectedLodging.pricing_structure_json.unit && (<>
            <h3>UNIT: {selectedLodging.description}, max {selectedLodging.max_occupancy} persons</h3>
            <form className="booking-form">
                <div className="form-group">
                    <label htmlFor="adults"># Adults</label>
                    <input
                        id="adults"
                        type="number"
                        min={0}
                        value={editedBooking.pricing_structure_json?.adults || 0}
                        onChange={(e) => handleInputChange(e.target.value, "adults")}
                        className="form-input"
                        required
                        disabled={editedBooking.booking_id ? true : false}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="children"># Children</label>
                    <input
                        id="children"
                        type="number"
                        min={0}
                        value={editedBooking.pricing_structure_json?.children || 0}
                        onChange={(e) => handleInputChange(e.target.value, "children")}
                        className="form-input"
                        required
                        disabled={editedBooking.booking_id ? true : false}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="infants"># Infants</label>
                    <input
                        id="infants"
                        type="number"
                        min={0}
                        value={editedBooking.pricing_structure_json?.infants || 0}
                        onChange={(e) => handleInputChange(e.target.value, "infants")}
                        className="form-input"
                        required
                        disabled={editedBooking.booking_id ? true : false}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="pensioners"># Pensioners</label>
                    <input
                        id="pensioners"
                        type="number"
                        min={0}
                        value={editedBooking.pricing_structure_json?.pensioners || 0}
                        onChange={(e) => handleInputChange(e.target.value, "pensioners")}
                        className="form-input"
                        required
                    />
                </div>
            </form>
        </>)}

        {
            pricingStructureKeys.length > 1 && selectedPricingKey ?
                <div>
                    <h3>UNIT: {selectedLodging.description}, max {selectedLodging.max_occupancy} persons</h3>
                    <form className="booking-form">
                        <div className="form-group">
                            <label htmlFor="selected_pricing">Pricing</label>
                            <select
                                id="selected_pricing"
                                value={selectedPricingKey}
                                onChange={(e) => handlePricingStructureChange(e.target.value)}
                                className="form-input"
                                required
                                disabled={editedBooking.booking_id ? true : false}
                            >
                                {pricingStructureKeys.map(pk => {
                                    return (<option key={pk} value={pk} style={{ textTransform: "capitalize" }}>{pk.replace("persons-", "Persons ")}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </form>
                    <form className="booking-form">
                        <div className="form-group">
                            <label htmlFor="adult_price">Adult price</label>
                            <input
                                id="adult_price"
                                type="number"
                                min={0}
                                value={editedBooking.pricing_structure_json?.adult_price || selectedPricing.adult_price}
                                onChange={(e) => handleInputChange(e.target.value, "adult_price")}
                                className="form-input"
                                required
                                disabled={editedBooking.booking_id ? true : false}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="adults"># Adults</label>
                            <input
                                id="adults"
                                type="number"
                                min={0}
                                value={editedBooking.pricing_structure_json?.adults || 0}
                                onChange={(e) => handleInputChange(e.target.value, "adults", selectedPricingKey)}
                                className="form-input"
                                required
                                disabled={editedBooking.booking_id ? true : false}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="child_price">Child price</label>
                            <input
                                id="child_price"
                                type="number"
                                min={0}
                                value={editedBooking.pricing_structure_json?.child_price || selectedPricing.child_price}
                                onChange={(e) => handleInputChange(e.target.value, "child_price")}
                                className="form-input"
                                required
                                disabled={editedBooking.booking_id ? true : false}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="children"># Children</label>
                            <input
                                id="children"
                                type="number"
                                min={0}
                                value={editedBooking.pricing_structure_json?.children || 0}
                                onChange={(e) => handleInputChange(e.target.value, "children", selectedPricingKey)}
                                className="form-input"
                                required
                                disabled={editedBooking.booking_id ? true : false}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="infant_price">Infant price</label>
                            <input
                                id="infant_price"
                                type="number"
                                min={0}
                                value={editedBooking.pricing_structure_json?.infant_price || selectedPricing.infant_price}
                                onChange={(e) => handleInputChange(e.target.value, "infant_price")}
                                className="form-input"
                                required
                                disabled={editedBooking.booking_id ? true : false}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="infants"># Infants</label>
                            <input
                                id="infants"
                                type="number"
                                min={0}
                                value={editedBooking.pricing_structure_json?.infants || 0}
                                onChange={(e) => handleInputChange(e.target.value, "infants", selectedPricingKey)}
                                className="form-input"
                                required
                                disabled={editedBooking.booking_id ? true : false}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="pensioner_price">Pensioner price</label>
                            <input
                                id="pensioner_price"
                                type="number"
                                min={0}
                                value={editedBooking.pricing_structure_json?.pensioner_price || selectedPricing.pensioner_price}
                                onChange={(e) => handleInputChange(e.target.value, "pensioner_price")}
                                className="form-input"
                                required
                                disabled={editedBooking.booking_id ? true : false}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="pensioners"># Pensioners</label>
                            <input
                                id="pensioners"
                                type="number"
                                min={0}
                                value={editedBooking.pricing_structure_json?.pensioners || 0}
                                onChange={(e) => handleInputChange(e.target.value, "pensioners", selectedPricingKey)}
                                className="form-input"
                                required
                                disabled={editedBooking.booking_id ? true : false}
                            />
                        </div>

                    </form>

                </div>


                : null
        }


    </div>
    );
}

export default BookingPricingStructure;